module.exports = __webpack_public_path__ + "static/media/news-13.64b13f05.jpg";